import { useQueryDetails, useQueryClient } from '@gogame/query';

import { loadConceptFamilyDetails } from 'scenes/Gallery/GalleryPage/ConceptFamilies/sources/conceptFamilies';

import { details, grids } from './queryKeyFactory';

export const useConceptFamilyDetails = ({ id }) => {
  const queryClient = useQueryClient();
  return useQueryDetails(details(id), () => loadConceptFamilyDetails({ id }), {
    initialData: () => {
      return queryClient
        .getQueryData(grids(), { exact: false })
        ?.rows?.find((d) => d.id === id);
    },
  });
};
